export default [{
  path: 'huo_ke_tong/:leftid',
  name: 'merchant_huo_ke_tong',
  component: () => import('@/views/merchant/admin/product_static_page/huo_ke_tong'),
  meta: {
    tpflag: 'merchant',
    title: '获客通-产品介绍',
  }
}, {
  path: 'mall_shop/:leftid',
  name: 'merchant_mall_shop',
  component: () => import('@/views/merchant/admin/product_static_page/mall_shop'),
  meta: {
    tpflag: 'merchant',
    title: '快叮商城-产品介绍',
  }
}, {
  path: 'yi_wu_yi_ma/:leftid',
  name: 'merchant_yi_wu_yi_ma',
  component: () => import('@/views/merchant/admin/product_static_page/yi_wu_yi_ma'),
  meta: {
    tpflag: 'merchant',
    title: '一物一码-产品介绍',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_product_static_page.js